import i18n from 'i18next'
import moment from 'moment'

import storage from '../../utils/constants/storage'

/**
 * Detecta o idioma do navegador e mapeia para os idiomas suportados
 * @returns {string} Código do idioma (pt, en, es)
 */
const detectBrowserLanguage = () => {
  // Idiomas suportados pela aplicação
  const supportedLanguages = ['pt', 'en', 'es']

  // Tenta obter o idioma do navegador
  const browserLang = (navigator.language || navigator.userLanguage || 'pt').toLowerCase()

  // Extrai apenas o código do idioma (ex: 'es-ES' -> 'es')
  const langCode = browserLang.split('-')[0]

  // Verifica se o idioma detectado está entre os suportados
  if (supportedLanguages.includes(langCode)) {
    return langCode
  }

  // Fallback para português se o idioma não for suportado
  return 'pt'
}

export const getLocale = (forceDetection = false) => {
  // Se forceDetection for true, ignora o localStorage e detecta o idioma do navegador
  if (forceDetection) {
    const browserLocale = detectBrowserLanguage()
    localStorage.setItem(storage.LOCALE_KEY, browserLocale)
    return browserLocale
  }

  // Primeiro verifica se há uma preferência salva no localStorage
  const savedLocale = localStorage.getItem(storage.LOCALE_KEY)
  if (savedLocale) {
    return savedLocale
  }

  // Se não houver preferência salva, detecta o idioma do navegador
  const browserLocale = detectBrowserLanguage()

  // Salva a detecção no localStorage para manter consistência
  localStorage.setItem(storage.LOCALE_KEY, browserLocale)

  return browserLocale
}

export const setLocale = lng => {
  i18n.changeLanguage(lng)
  // Configura o moment.js com o locale correto
  const momentLocale = lng === 'pt' ? 'pt-br' : lng === 'es' ? 'es' : 'en-gb'
  moment.locale(momentLocale, { week: { dow: 1 } })
  return localStorage.setItem(storage.LOCALE_KEY, lng)
}

/**
 * Reseta o locale e detecta novamente o idioma do navegador
 * Útil para testar a detecção automática ou quando o usuário quer usar o idioma do navegador
 */
export const resetLocale = () => {
  localStorage.removeItem(storage.LOCALE_KEY)
  const browserLocale = detectBrowserLanguage()
  setLocale(browserLocale)
  return browserLocale
}
